export const accessCheck_disabled = (src, element) => {
  const access = sessionStorage.getItem("user-accessLevel");
  const is_leader = sessionStorage.getItem("is_leader");
  let output = false;
  const pgsCustomHandling = ["chase-dash"];
  if (!pgsCustomHandling.includes(src)) {
    switch (element) {
      case "office":
        output = Number(access) >= 3;
        return !output;

      case "team":
        output =
          (Number(access) == 2 && Number(is_leader) === 1) ||
          Number(access) >= 3;
        return !output;

      case "agent":
        output =
          (Number(access) == 2 && Number(is_leader) === 1) ||
          Number(access) >= 3;
        return !output;
    }
  } else {
    if (src === "chase-dash" && element === "topAgents") {
      output =
        (Number(access) == 2 && Number(is_leader) === 1) || Number(access) >= 3;
      return output;
    }
  }
};

export const accessCheck_setFilter = (src, data, element) => {
  let output = "All";
  const pgsCustomHandling = [];
  if (!pgsCustomHandling.includes(src)) {
    switch (element) {
      case "office":
        output = sessionStorage.getItem("user-officeId");
        return output;
      case "office-leaderboard":
        output = Number(sessionStorage.getItem("user-accessLevel")) < 3 ? sessionStorage.getItem("user-officeId") : 'All';
        return output;

      case "team":
        checkDataContains_agentFilterVal(data, "team_id", "team_id");
        output = sessionStorage.getItem("team_id");
        return output;

      case "agent":
        output = sessionStorage.getItem("user-id");
        return output;
    }
  } else {
    console.log("custom handling");
  }
};

export const checkDataContains_agentFilterVal = (data, key, sessionKey) => {
  let match = 0;
  match = data.filter((f) => f[key] == sessionStorage.getItem(sessionKey));
  return match.length;
};

export const isDisabled_agentDash = (type, userAccess, isLeader, loading) =>{
  if(loading){
    return true;
  }else{
    if(userAccess == 2 && Number(isLeader) > 0 && type === 'agent'){
      return false;
    }else if(userAccess == 3 && ['agent', 'team'].includes(type)){
      return false;
    }else if(userAccess > 3){
      return false;
    }else{
      return true;
    }
  }

}

export const setSessionAccess = (id, name, access_id, accessGranted, accessLevel, officeId, office, is_leader, team_id, team_name, department_id, department) => {
     
      sessionStorage.setItem("user-id",  Number(id) );
      sessionStorage.setItem("user-name", name);
      sessionStorage.setItem("user-accessId", access_id);
      sessionStorage.setItem("user-accessType", accessGranted);
      sessionStorage.setItem("user-accessLevel", accessLevel);

      sessionStorage.setItem("user-officeId", officeId);
      sessionStorage.setItem("user-office", office);
      sessionStorage.setItem("is_leader", is_leader ? is_leader : 0);

      sessionStorage.setItem("team_id", team_id ? team_id : 0);
      sessionStorage.setItem("team_name", team_name ? team_name : 0 );
      sessionStorage.setItem("department_id", department_id ? department_id : 0);
      sessionStorage.setItem("department", department ? department : 0 );
}

export const LogOut = () =>{
  console.warn("log out has been clicked");
  sessionStorage.removeItem("user-id");
  sessionStorage.removeItem("user-name");
  sessionStorage.removeItem("user-accessId");
  sessionStorage.removeItem("user-accessType");
  sessionStorage.removeItem("user-accessLevel");
  sessionStorage.removeItem("user-officeId");
  sessionStorage.removeItem("user-office");
  sessionStorage.removeItem("is_leader");
  sessionStorage.removeItem("team_id");
  sessionStorage.removeItem("team_name");
  sessionStorage.removeItem("mainUser_id");
  sessionStorage.removeItem("mainUser_name");
  location.reload();
  // navigate("/");
}
